import Intro from "../../../../src/components/context-magic/intro";
import * as React from 'react';
export default {
  Intro,
  React
};